var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { getStyleNames } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { ListRow } from '../../Select.styled';
import { disabledStyles, focusedRowStyles, groupedItemStyles, fixedRowGridStyles, fixedRowListStylesSelected, } from '../../../styles/legacy';
import { disabledStyles as disabledStylesCitrus2022, focusedRowStyles as focusedRowStylesCitrus2022, groupedItemStyles as groupedItemStylesCitrus2022, fixedRowGridStyles as fixedRowGridStylesCitrus2022, fixedRowListStylesSelected as fixedRowListStylesSelectedCitrus2022, } from '../../../styles/citron';
import PctyInputSelectEmployee from './SelectEmployee';
var _FixedSizeGridRow = function (_a) {
    var _b;
    var index = _a.index, id = _a.id, isFocused = _a.isFocused, _c = _a.isScrolling, isScrolling = _c === void 0 ? false : _c, isScrollingPlaceholderText = _a.isScrollingPlaceholderText, style = _a.style, data = _a.data, onChange = _a.onChange, onMouseHover = _a.onMouseHover, other = _a.other, renderAvatar = _a.renderAvatar, 
    // FIXME: check if `props` is needed here
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props = __rest(_a, ["index", "id", "isFocused", "isScrolling", "isScrollingPlaceholderText", "style", "data", "onChange", "onMouseHover", "other", "renderAvatar"]);
    var isCitron = useTheme().citrus2022;
    var evenOrOdd = index % 2 ? 'ListItemOdd' : 'ListItemEven';
    var rowId = "".concat(id, "-select-row-").concat(index);
    var noHeaderCursor = {
        cursor: 'unset',
    };
    var headerItem = {
        paddingTop: '16px',
    };
    var fixedRowGridStylesObj = isCitron ? fixedRowGridStylesCitrus2022 : fixedRowGridStyles;
    var fixedRowListStylesSelectedObj = isCitron ? fixedRowListStylesSelectedCitrus2022 : fixedRowListStylesSelected;
    var disabledStylesObj = isCitron ? disabledStylesCitrus2022 : disabledStyles;
    var focusedRowStylesObj = isCitron ? focusedRowStylesCitrus2022 : focusedRowStyles;
    var groupedItemStylesObj = isCitron ? groupedItemStylesCitrus2022 : groupedItemStyles;
    var emotionObj = (_b = {},
        _b[emotionCss(fixedRowGridStylesObj)] = true,
        _b[emotionCss(fixedRowListStylesSelectedObj)] = !data.disabled && data.selected,
        _b[emotionCss(focusedRowStylesObj)] = !data.disabled && isFocused && !data.selected,
        _b[emotionCss(groupedItemStylesObj)] = data.groupId && !data.header,
        _b[emotionCss(noHeaderCursor)] = !data.disabled && !isFocused && data.header,
        _b[emotionCss(headerItem)] = !data.disabled && data.header,
        _b[emotionCss(disabledStylesObj)] = data.disabled,
        _b[emotionCss(style)] = true,
        _b["".concat(evenOrOdd)] = true,
        _b);
    var classes = cx(emotionObj);
    var styleNames = {
        fixedRowGridStylesObj: emotionObj[emotionCss(fixedRowGridStylesObj)],
        fixedRowListStylesSelectedObj: emotionObj[emotionCss(fixedRowListStylesSelectedObj)],
        focusedRowStylesObj: emotionObj[emotionCss(focusedRowStylesObj)],
        groupedItemStylesObj: emotionObj[emotionCss(groupedItemStylesObj)],
        noHeaderCursor: emotionObj[emotionCss(noHeaderCursor)],
        headerItem: emotionObj[emotionCss(headerItem)],
        disabledStylesObj: emotionObj[emotionCss(disabledStylesObj)],
        style: emotionObj[emotionCss(style)],
    };
    var emptyCreatable = function (event) {
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
        data.onMouseDown();
    };
    if (data.creatable) {
        return (React.createElement(ListRow, { className: classes, onMouseDown: emptyCreatable, onTouchStart: emptyCreatable, styleNames: getStyleNames(styleNames) }, data.label));
    }
    var emptyMouseDown = function (event) {
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
    };
    if (data.empty) {
        return (React.createElement(ListRow, { className: classes, onMouseDown: emptyMouseDown, onTouchStart: emptyMouseDown, styleNames: getStyleNames(styleNames) }, data.label));
    }
    var handleRowSelection = function (_a) {
        var event = _a.event;
        if (event.type !== 'touchstart')
            event.preventDefault();
        event.stopPropagation();
        if (onChange)
            onChange(data.optionsIndex);
    };
    var toggleFocus = function () {
        if (onMouseHover) {
            onMouseHover(index);
        }
    };
    var singleRow = function () {
        var label = data.label;
        if (isScrolling) {
            return (React.createElement(ListRow, { className: classes, styleNames: getStyleNames(styleNames) }, isScrollingPlaceholderText || 'scrolling'));
        }
        if (data.header) {
            return (React.createElement(ListRow, { className: classes, id: rowId, onTouchStart: function (event) { return handleRowSelection({ event: event }); }, onMouseDown: function (event) { return handleRowSelection({ event: event }); }, onMouseEnter: function () { return toggleFocus(); }, styleNames: getStyleNames(styleNames) }, label));
        }
        return (React.createElement("div", null,
            React.createElement(PctyInputSelectEmployee, { className: classes, disabled: data.disabled, id: "".concat(id, "-grid-list-").concat(index), index: index, item: data.value, key: "pcty-input-select-employee-item-".concat(id, "-").concat(index), onMouseDown: function (event) { return handleRowSelection({ event: event }); }, onMouseEnter: function () { return toggleFocus(); }, onTouchStart: function (event) { return handleRowSelection({ event: event }); }, renderAvatar: renderAvatar, selected: data.selected })));
    };
    return singleRow();
};
_FixedSizeGridRow.defaultProps = {
    __TYPE: 'FixedSizeListRow',
};
export default _FixedSizeGridRow;
